import { useRef } from 'react';
import { Link } from 'react-router-dom';
import ComicCard from '@/components/base/ComicCard';
import { hotComics } from '@/mocks/comics';

export default function FeaturedGrid() {
  const scrollRef = useRef<HTMLDivElement>(null);

  const scroll = (dir: 'left' | 'right') => {
    if (scrollRef.current) {
      const amount = 240;
      scrollRef.current.scrollBy({ left: dir === 'left' ? -amount : amount, behavior: 'smooth' });
    }
  };

  return (
    <section className="py-16 md:py-24 bg-primary-50/40">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-[32px] md:text-[40px] font-black text-foreground-900">
              热门<span className="text-primary-500">连载</span>
            </h2>
            <p className="mt-2 text-sm text-foreground-400">每日更新，精彩不容错过</p>
          </div>
          <Link
            to="/category/romance"
            className="hidden md:inline-flex items-center gap-1.5 text-sm font-medium text-accent-500 hover:text-accent-600 transition-colors whitespace-nowrap cursor-pointer"
          >
            实时更新
            <i className="ri-arrow-right-line" style={{ width: '14px', height: '14px' }} />
          </Link>
        </div>

        <div className="relative">
          <button
            onClick={() => scroll('left')}
            className="hidden md:flex absolute left-0 top-1/2 -translate-y-1/2 -translate-x-3 z-10 w-10 h-10 rounded-full bg-white text-foreground-600 items-center justify-center hover:text-primary-500 transition-colors cursor-pointer border border-background-200/60"
            aria-label="向左滑动"
          >
            <i className="ri-arrow-left-s-line text-lg" style={{ width: '18px', height: '18px' }} />
          </button>

          <div
            ref={scrollRef}
            className="flex gap-5 overflow-x-auto scrollbar-hide pb-2 -mx-4 md:mx-0 px-4 md:px-0"
            style={{ scrollSnapType: 'x mandatory' }}
          >
            {hotComics.map((comic) => (
              <div key={comic.id} style={{ scrollSnapAlign: 'start' }}>
                <ComicCard comic={comic} variant="hot" />
              </div>
            ))}
            <div className="flex-shrink-0 w-[60px] md:w-[80px]" />
          </div>

          <button
            onClick={() => scroll('right')}
            className="hidden md:flex absolute right-0 top-1/2 -translate-y-1/2 translate-x-3 z-10 w-10 h-10 rounded-full bg-white text-foreground-600 items-center justify-center hover:text-primary-500 transition-colors cursor-pointer border border-background-200/60"
            aria-label="向右滑动"
          >
            <i className="ri-arrow-right-s-line text-lg" style={{ width: '18px', height: '18px' }} />
          </button>
        </div>
      </div>
    </section>
  );
}